/**
 * ExperimentsPageV2 — A/B experiments list shell (V2 redesign).
 *
 * Single coral "+ New Experiment" header action; the body
 * (ExperimentsTableV2) renders the status pills + inline edit.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ExperimentsTableV2 from '../../../ExperimentsTable/v2/ExperimentsTableV2';
import { PageHeader, Button } from '../../../redesign';

const PlusSign = (
  <span style={{ fontSize: 16, lineHeight: 1 }} aria-hidden>+</span>
);

export default function ExperimentsPageV2() {
  const total = useSelector((s) =>
    Array.isArray(s.experiments?.experiments) ? s.experiments.experiments.length : undefined,
  );
  const totalLabel = total != null ? `${total.toLocaleString()} total` : undefined;

  return (
    <div className="bg-bg min-h-full">
      <PageHeader
        eyebrow="Experiments"
        title="A/B Experiments"
        total={totalLabel}
        actions={
          <Link to="/experiments/add" className="no-underline">
            <Button variant="coral" leadingIcon={PlusSign}>
              New Experiment
            </Button>
          </Link>
        }
      />
      <ExperimentsTableV2 />
    </div>
  );
}
